// extracted by mini-css-extract-plugin
export const root = "youtube-player-module--root--1Qh3K";
export const player = "youtube-player-module--player--5lce_";